const BACKGROUND_STAY_CUSTOM_ACTION =
    'GIL034: El cliente ha vuelto de estar la app en segundo plano o de perder el foco del navegador y ha decidido continuar con el onboarding.',
  BACKGROUND_SUCCESS_CUSTOM_ACTION =
    'GIL035: El cliente ha conseguido refrescar satisfactoriamente la app tras haber estado en segundo plano o haber perdido el foco del navegador.';

export { BACKGROUND_STAY_CUSTOM_ACTION, BACKGROUND_SUCCESS_CUSTOM_ACTION };
